<div class="business-navbar__button-container">
    <button class="business-navbar__button" [disabled]="loading || disabled"
            [class.business-navbar__button--raised]="raised"
            [class.business-navbar__button--loading]="loading"
            [class.business-navbar__button--disabled]="loading || disabled"
            (click)="onButtonClick($event)">
        {{ text }}
    </button>
    <div class="business-navbar__button__overlay"></div>
    <atlas-loader class="business-navbar__button__loader" [size]="24" [color]="'#fff'" *ngIf="loading"></atlas-loader>
</div>
